export default __webpack_public_path__ + "static/assets/7d3a3face346890508fb5b63c25715ee.png";